/**
 * Do not edit directly
 */

export const componentAlertActionButtonFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentAlertActionButtonFontSize = "0.875rem";
export const componentAlertActionButtonHeight = "1.25rem";
export const componentAlertActionButtonTextDecorationDefault = "underline";
export const componentAlertActionButtonTextDecorationFocus = "none";
export const componentAlertActionButtonTextWrap = "nowrap";
export const componentAlertActionButtonVariantErrorTextColorDefault = "#9b1419";
export const componentAlertActionButtonVariantErrorTextColorFocus = "#000";
export const componentAlertActionButtonVariantInfoTextColorDefault = "#000";
export const componentAlertActionButtonVariantInfoTextColorFocus = "#000";
export const componentAlertActionButtonVariantSuccessTextColorDefault = "#1d5f02";
export const componentAlertActionButtonVariantSuccessTextColorFocus = "#000";
export const componentAlertActionButtonVariantWarningTextColorDefault = "#662b0d";
export const componentAlertActionButtonVariantWarningTextColorFocus = "#000";
/**
 * @deprecated `component.alert.actionButton.whiteSpace` has been deprecated. Please use `component.alert.actionButton.textWrap` instead.
 */
export const componentAlertActionButtonWhiteSpace = "nowrap";
export const componentAlertContainerBorderRadius = "0.25rem";
export const componentAlertContainerBorderWidthBottom = "0.0625rem";
export const componentAlertContainerBorderWidthEnd = "0.0625rem";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.borderWidthStart` instead.
 */
export const componentAlertContainerBorderWidthLeft = "0.25rem";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.borderWidthEnd` instead.
 */
export const componentAlertContainerBorderWidthRight = "0.0625rem";
export const componentAlertContainerBorderWidthStart = "0.25rem";
export const componentAlertContainerBorderWidthTop = "0.0625rem";
export const componentAlertContainerFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentAlertContainerFontSize = "0.875rem";
export const componentAlertContainerFontWeight = 400;
export const componentAlertContainerLineHeight = "1.25rem";
export const componentAlertContainerPaddingHorizontal = "1rem";
export const componentAlertContainerPaddingVertical = "0.5rem";
export const componentAlertContainerVariantErrorBackgroundColor = "#fce8e9";
export const componentAlertContainerVariantErrorBorderColorBottom = "#ef8e92";
export const componentAlertContainerVariantErrorBorderColorEnd = "#ef8e92";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.error.borderColorStart` instead.
 */
export const componentAlertContainerVariantErrorBorderColorLeft = "#de1c24";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.error.borderColorEnd` instead.
 */
export const componentAlertContainerVariantErrorBorderColorRight = "#ef8e92";
export const componentAlertContainerVariantErrorBorderColorStart = "#de1c24";
export const componentAlertContainerVariantErrorBorderColorTop = "#ef8e92";
export const componentAlertContainerVariantErrorTextColor = "#9b1419";
export const componentAlertContainerVariantInfoBackgroundColor = "#f1f1f2";
export const componentAlertContainerVariantInfoBorderColorBottom = "#babbbe";
export const componentAlertContainerVariantInfoBorderColorEnd = "#babbbe";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.info.borderColorStart` instead.
 */
export const componentAlertContainerVariantInfoBorderColorLeft = "#000";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.info.borderColorEnd` instead.
 */
export const componentAlertContainerVariantInfoBorderColorRight = "#babbbe";
export const componentAlertContainerVariantInfoBorderColorStart = "#000";
export const componentAlertContainerVariantInfoBorderColorTop = "#babbbe";
export const componentAlertContainerVariantInfoTextColor = "#000";
export const componentAlertContainerVariantSuccessBackgroundColor = "#eaf3e6";
export const componentAlertContainerVariantSuccessBorderColorBottom = "#95c381";
export const componentAlertContainerVariantSuccessBorderColorEnd = "#95c381";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.success.borderColorStart` instead.
 */
export const componentAlertContainerVariantSuccessBorderColorLeft = "#2a8703";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.success.borderColorEnd` instead.
 */
export const componentAlertContainerVariantSuccessBorderColorRight = "#95c381";
export const componentAlertContainerVariantSuccessBorderColorStart = "#2a8703";
export const componentAlertContainerVariantSuccessBorderColorTop = "#95c381";
export const componentAlertContainerVariantSuccessTextColor = "#1d5f02";
export const componentAlertContainerVariantWarningBackgroundColor = "#fff9e9";
export const componentAlertContainerVariantWarningBorderColorBottom = "#ffe190";
export const componentAlertContainerVariantWarningBorderColorEnd = "#ffe190";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.warning.borderColorStart` instead.
 */
export const componentAlertContainerVariantWarningBorderColorLeft = "#ffc220";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.container.variant.warning.borderColorEnd` instead.
 */
export const componentAlertContainerVariantWarningBorderColorRight = "#ffe190";
export const componentAlertContainerVariantWarningBorderColorStart = "#ffc220";
export const componentAlertContainerVariantWarningBorderColorTop = "#ffe190";
export const componentAlertContainerVariantWarningTextColor = "#662b0d";
export const componentAlertIconIconSize = "small";
export const componentAlertIconMarginEnd = "0.5rem";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.alert.icon.marginEnd` instead.
 */
export const componentAlertIconMarginRight = "0.5rem";
export const componentAlertIconVariantErrorIconColor = "#9b1419";
export const componentAlertIconVariantErrorIconName = "ExclamationCircle";
export const componentAlertIconVariantInfoIconColor = "#000";
export const componentAlertIconVariantInfoIconName = "InfoCircle";
export const componentAlertIconVariantSuccessIconColor = "#1d5f02";
export const componentAlertIconVariantSuccessIconName = "CheckCircle";
export const componentAlertIconVariantWarningIconColor = "#662b0d";
export const componentAlertIconVariantWarningIconName = "Warning";
export const componentAlertLabelContainerGapHorizontal = "1rem";
export const componentAlertLabelContainerGapVertical = "0.25rem";
export const componentAlertLabelContainerWrap = "wrap";